<script lang="ts">
    import { onDestroy, onMount } from 'svelte';
    import { get } from 'svelte/store';

    import createOnShowAction from '../../../utils/trackingDOM';
    import AddressInfo from '../components/AddressInfo.svelte';
    import AdvCookieNotice from '../components/AdvCookieNotice.svelte';
    import AdvRetentionDialog from '../components/AdvRetentionDialog.svelte';
    import ApplyStepForm from '../components/ApplyStepForm.svelte';
    import BenefitInfo from '../components/BenefitInfo.svelte';
    import DownloadCountdown from '../components/DownloadCountdown.svelte';
    import GlobalToast from '../components/GlobalToast.svelte';
    import LoginHeader from '../components/loginHeader.svelte';
    import PhoneModule from '../components/PhoneModule.svelte';
    import QuickDownload from '../components/QuickDownload.svelte';
    import { GroupType } from '../constants/common';
    import { themeType } from '../constants/Enums';
    import { JUMP_TYPE_ENUM } from '../enums';
    import {
        AWARD_PAGE_CK,
        AWARD_PAGE_EXPOSE_SW,
        EXPOSE_FAIL_SW,
        EXPOSE_SUCCESS_SW,

    } from '../enums/track';
    import {
        visible,
        isLogin,
        authChecking,
        isLoading,
        cookieHeight,
        isCookiesShow,
        groupType,
        loadingReward,
        isParticipateActivity,
        globalToastMessage,
        regPageExposeAt,
        awardCountdownSecondsLeft,
        activityId
    } from '../store/index';
    import { startPreload } from '../store/preloader';
    import { sendEventOnce } from '../utils/event';
    import { getH5creditCardUrl, JumpLink } from '../utils/jumpTo';
    import { attachOfflineToast } from '../utils/offlineToast';
    import { checkIsLogin } from '../utils/passport';
    import { getMatchedRewardActivityId, applyRewardClaimToStore } from '../utils/rewardClaimStorage';
        import { trackEvent } from '../utils/track';

    import QuickDownLoad from './../../MXCreditCardW2A/components/QuickDownLoad.svelte';

    import webp from '@/actions/webp';
    import { DIDI_LOGO, DIDI_LOGO_LINE } from '@/configs/images.ts';
    import { httpPost } from '@/services/signRequest';
    import { reportP4Direct } from '@/utils/fmpTrack';
    import { getParamsUI, GROUP_TYPE_PARAM } from '@/utils/group';
    import { initializePreloadIframe } from '@/utils/preload';
    import { trackEventModuleSw } from '@/utils/techTrack';

    const type = getParamsUI(GROUP_TYPE_PARAM, 'A', 'A');

    $groupType = GroupType[type];
    startPreload('A');
    const pageLoading = false;
    let phoneInputRef;
    let detachOfflineToast: (() => void) | undefined;
    let mainPageOnShowFired = false;
    const hasAwardExposeTracked = false;
    const hasRegExposeTracked = false;

    const handlePolicyClose = () => {
        if (phoneInputRef) {
            phoneInputRef.handleClose();
        }
    };

    const handleAwardOtherAreaClick = async (e: MouseEvent) => {
        if (!$isParticipateActivity) return;
        try {
            const target = e.target as HTMLElement | null;

            if (target?.closest('adv-retention-dialog')) {
                return;
            }

            if (
                target?.closest('.box-white-download') ||
                target?.closest('.download-countdown')
            ) {
                return;
            }
        } catch {
            return;
        }

        trackEvent(AWARD_PAGE_CK, {
            button_name: 'other'
        });

        await JumpLink(JUMP_TYPE_ENUM.TO_H5CREDITCARD, {
            awardCountdownNumber: get(awardCountdownSecondsLeft) ?? 0
        });
    };

    const handleAwardOtherAreaKeydown = async (e: KeyboardEvent) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        try {
            e.preventDefault();
        } catch {}

        await handleAwardOtherAreaClick(e as unknown as MouseEvent);
    };
    const mainPageShowAction = createOnShowAction(() => {
        mainPageOnShowFired = true;
    });

    onMount(async () => {
        $regPageExposeAt = Date.now();
        trackEvent(EXPOSE_SUCCESS_SW);
        detachOfflineToast = attachOfflineToast((msg) =>{
            globalToastMessage.set(msg);
            trackEvent(EXPOSE_FAIL_SW, {
                error_msg: 'page_offline_error',
                error_code: '1001'
            });
        });
        reportP4Direct();
        trackEventModuleSw('main_page_sw');

        try {
            await checkIsLogin();
        } catch (e) {
            console.error('[checkIsLogin]', e);
        } finally {
            authChecking.set(false);
        }

        applyRewardClaimToStore();

        if ($isLogin) {
            const claimedAid = getMatchedRewardActivityId();

            if (claimedAid) {
                $activityId = claimedAid;
                initializePreloadIframe(getH5creditCardUrl(), false);
            }
        }
    });

    onDestroy(() => {
        detachOfflineToast?.();
    });

</script>

<div
    class="creditcard-page creditcard-page--intro-a"
    use:mainPageShowAction
    class:loading-reward-page={$loadingReward}
    style={'transition: padding-bottom 0.3s ease; padding-bottom: ' +
        ($isCookiesShow ? $cookieHeight : 0) +
        'px;'}
    on:click={handleAwardOtherAreaClick}
    on:keydown={handleAwardOtherAreaKeydown}
    role="button"
    tabindex="0"
>
    {#if $visible && !$isParticipateActivity && !$loadingReward}
        <QuickDownload logo={DIDI_LOGO_LINE} downLoadType={themeType.WHITE}
        ></QuickDownload>
    {/if}
    <LoginHeader themeType={themeType.WHITE}></LoginHeader>
    {#if !$loadingReward && !$isParticipateActivity}
        <PhoneModule themeType={themeType.WHITE}></PhoneModule>
        <ApplyStepForm themeType={themeType.WHITE}></ApplyStepForm>
        <div class="box-white-content"></div>
        <BenefitInfo themeType={themeType.WHITE} />
        <AddressInfo themeType={themeType.WHITE} topPadding={true} />
        <AdvCookieNotice />
    {:else if $isParticipateActivity}
        <div
            class="box-white"
            class:box-white--success={$isParticipateActivity}
        >
            <ApplyStepForm themeType={themeType.WHITE}></ApplyStepForm>
            <QuickDownload
                logo={DIDI_LOGO_LINE}
                downLoadType={themeType.WHITE}
                isBottom={true}
            ></QuickDownload>
        </div>
        <DownloadCountdown themeType={themeType.WHITE} />
    {/if}
    <AdvRetentionDialog />
</div>
<GlobalToast />

<style lang="scss">
    .creditcard-page {
        margin: auto;
        margin-top: 0;
        width: 7.5rem;
        height: 100%;
        position: relative;
        overflow-x: hidden;
        font-family: DiDiSans-Pro-Regular;
        user-select: none;
        background-color: #ffffff;
        padding: 0;
        box-sizing: border-box;
        /* 确保文本渲染清晰 */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        letter-spacing: 0;
        transition: padding-bottom 0.3s ease;
    }
    .box-white {
        box-sizing: border-box;
        margin-bottom: 307px;
        background-color: #ffffff;
    }
    .box-white-content {
        width: 100%;
        height: 40px;
        background-color: #ffffff;
    }
    .creditcard-page.loading-reward-page {
        min-height: 100vh;
        background-color: #eef3ff;
    }

    /* 白底页：T&C / Log out 纯黑字，横向「Log out | T&C」（对齐 introA-1） */
    .creditcard-page--intro-a :global(.login-header__bar-actions) {
        flex-direction: row;
        align-items: center;
        gap: 0;
    }

    .creditcard-page--intro-a :global(.login-header__logout),
    .creditcard-page--intro-a :global(.login-header__rules) {
        color: #000000 !important;
        background: transparent !important;
        background-color: transparent !important;
        border-radius: 0;
        padding: 0;
        min-width: unset;
        height: auto;
        line-height: 32px;
    }

    .creditcard-page--intro-a :global(.login-header__logout::after) {
        content: '｜';
        display: inline-block;
        margin: 0 0.16rem;
        color: #000000;
        pointer-events: none;
        font-weight: 400;
        line-height: 32px;
        vertical-align: middle;
    }
</style>
